import React from "react";
import { Form, Field } from "formik";

import AntDesignInputWithFormik from "../components/AntDesignInputWithFormik";

const AddAndEditLessonForm = () => (
  <Form>
    <Field
      name="title"
      component={AntDesignInputWithFormik}
      placeholder="Title"
      label="Title"
    />
    <Field
      name="order"
      component={AntDesignInputWithFormik}
      placeholder="Order"
      label="Order"
      type="number"
    />
    <Field
      name="src_path"
      component={AntDesignInputWithFormik}
      placeholder="Video URL"
      label="Video URL"
    />
  </Form>
);

export default AddAndEditLessonForm;
